// extracted by mini-css-extract-plugin
export default {"skeletonRow":"MwyfPy","tldChip":"wEtt7K","tldChipSelected":"ZTwofA"};